import { skedInboxApi } from "./_skedInboxApi";
import { Pagination, Message } from "types/conversationInbox";
import type { CreateMessageRequest } from "../shared/inbox/message-requests";

interface getMessagesProps {
  conversationId: string;
  next?: string | null;
}

export async function getMessages({
  conversationId,
  next,
}: getMessagesProps): Promise<{
  data: Pagination<Message>;
}> {
  return await skedInboxApi.get("/messages", {
    params: {
      conversationId,
      sort: "createdAt:DESC",
      next,
    },
  });
}

export async function getMessage(
  id: string,
  options?: { populateSender?: boolean }
): Promise<{ data: Message }> {
  return await skedInboxApi.get(
    `/messages/${id}`,
    options ? { params: options } : undefined
  );
}

export async function getMessagesBatch({
  requests,
}: {
  requests: getMessagesProps[];
}): Promise<{
  data: Array<Pagination<Message> & { conversationId: string }>;
}> {
  return await skedInboxApi.post("/messages/batch", {
    requests: requests.map((request) => ({
      conversationId: request.conversationId,
      next: request.next,
      sort: "createdAt:DESC",
    })),
  });
}

export async function createMessage({
  conversationId,
  text,
  isInternal,
  closeConversationAction,
  replyToId,
  attachments,
}: CreateMessageRequest): Promise<{
  data: Message & {
    statusSnapshot?: { status: "OPEN" | "CLOSED"; statusRevision: number };
  };
}> {
  return await skedInboxApi.post("/messages", {
    conversationId,
    text,
    isInternal,
    closeConversation: !!closeConversationAction,
    replyToId,
    attachments,
  });
}

export async function setMessageDeletedStatus({
  id,
}: {
  id: string;
}): Promise<void> {
  await skedInboxApi.put(`/messages/${id}/deleted-status`, {});
}
export async function setMessageHidden({
  id,
  hidden,
}: {
  id: string;
  hidden: boolean;
}): Promise<void> {
  await skedInboxApi.put(`/messages/${id}/hidden-status`, {
    hidden,
  });
}

export async function setMessageSentiment({
  id,
  sentiment,
}: {
  id: string;
  sentiment: number;
}): Promise<{
  data: Message & { conversationSentimentType?: number };
}> {
  return await skedInboxApi.patch(`/messages/${id}/sentiment`, {
    sentiment,
  });
}

export async function setMessageText({
  id,
  text,
}: {
  id: string;
  text: string;
}): Promise<{
  data: Message;
}> {
  return await skedInboxApi.patch(`/messages/${id}/text`, {
    text,
  });
}
